/**
 * @generated SignedSource<<d8497ae7fd5958bfc5be4b6919c15dd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type accountDeleteAccountUserMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type accountDeleteAccountUserMutation$data = {
  readonly deleteAccountUserInvitation: {
    readonly id: string;
  };
};
export type accountDeleteAccountUserMutation = {
  response: accountDeleteAccountUserMutation$data;
  variables: accountDeleteAccountUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDeleteAccountUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AccountUserInvitationDeletePayload",
        "kind": "LinkedField",
        "name": "deleteAccountUserInvitation",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "accountDeleteAccountUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AccountUserInvitationDeletePayload",
        "kind": "LinkedField",
        "name": "deleteAccountUserInvitation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e379a28a5732accf2bcf2faee4dfe3f",
    "id": null,
    "metadata": {},
    "name": "accountDeleteAccountUserMutation",
    "operationKind": "mutation",
    "text": "mutation accountDeleteAccountUserMutation(\n  $id: ID!\n) {\n  deleteAccountUserInvitation(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "dfc37cb7cfd07a459b3e6c95f49892d6";

export default node;
